export default {"src":"https://s.sylndr.com/c-7fdbb5e/_next/static/media/service1.54bac454.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};